"use client";

import { useEffect, useState } from "react";
import { Config, PropertyType, Template } from "src/types";
import { componentMapDynamic } from "../../SelectedTemplateComponent";
import { mockConfig } from "../../constants/mockConfig";
import { useTheme } from "../../contexts/useTheme";

const validTemplates: Template[] = ["design1", "design2", "design3"];

interface HomeSwitchProps {
  initialDesign?: Template | null;
  properties?: PropertyType[];
  config?: Config;
}

const HomeSwitch = ({ initialDesign, properties }: HomeSwitchProps) => {
  const { setTemplate, config } = useTheme();


  const [hasHandled, setHasHandled] = useState(false);
  const [isClient, setIsClient] = useState(false);

  // Set isClient to true on mount
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Handle initialDesign from server or URL parameter in demo mode
  useEffect(() => {
    if (!isClient) return;
    // Prioritize server-provided initialDesign
    if (initialDesign && validTemplates.includes(initialDesign)) {

      setTemplate(initialDesign);
      setHasHandled(true);
      const params = new URLSearchParams(window.location.search);
      params.delete("design");
      const newUrl =
        window.location.pathname +
        (params.toString() ? `?${params.toString()}` : "");

      window.history.replaceState({}, "", newUrl);
      return;
    }
  }, [initialDesign, isClient, hasHandled]);

  if (!isClient) {
    const pageComponents = componentMapDynamic["home"];
    const SelectedComponent =
      pageComponents[config?.template as Template] || pageComponents["design3"];
    return (
      <SelectedComponent
        config={config as Config}
        listings={properties}
        styling={mockConfig.styling}
      />
    );
  }

  const pageComponents = componentMapDynamic["home"];
  const SelectedComponent =
    pageComponents[config?.template as Template] || pageComponents["design3"];
  return (
    <SelectedComponent
      config={config as Config}
      listings={properties}
      styling={mockConfig.styling}
    />
  );
};

export default HomeSwitch;
